<template>
  <div class="default-title">
     <el-form label-width="60px" ref="form" :model="form" class="list-top-margin" :size="buttonSize" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称" prop="unitName">
              <el-input size="small" v-model="form.unitName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input size="small" v-model="form.remark" type="textarea" :rows="2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="text-align-center" style="position: relative;">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" class="title" @click="save">确 定</el-button>
      </div>
  </div>
</template>
<script>
import { unitSave } from '@/api/basicData'
import Pagination from '@/components/Pagination'
import moment from 'moment';
export default {
  components: {
    Pagination,
  },
  props:['userData','editRow','modelStatus'],
  data() {
    return {
      buttonSize:'small',
      form:{
        unitName:'',
        remark:'',
      },
      rules:{
        unitName: [{
            required: true,
            message: "请输入名称",
            trigger: "blur",
        },] ,
      },
    }
  },
  created() {
    if(this.modelStatus == 'edit'){
      this.form = JSON.parse(JSON.stringify(this.editRow));
      // this.form.unitName = this.editRow.unitName
      // this.form.remark = this.editRow.remark
      // this.form._id = this.editRow._id
    }
  },
  methods:{
    cancel(){
      this.$emit('done',{type:'cancel'})
    },
    save(){
      this.$refs.form.validate((valid) => {
          if (valid) {
            var data = JSON.parse(JSON.stringify(this.form));

            if(this.modelStatus != 'edit'){
              data.factoryId = this.userData.factoryId;
              data.creater = this.userData.name+'('+this.userData.account+')';
              data.updater = this.userData.name+'('+this.userData.account+')';
              // data.createTime = moment().format('YYYY-MM-DD HH:mm:ss');
            }else{
              data.updater = this.userData.name+'('+this.userData.account+')';
              // data.updateTime = moment().format('YYYY-MM-DD HH:mm:ss');
            }
            unitSave(data).then(res => {
              if(res.code == 200){
                this.$message.success('保存成功')
                this.$emit('done',{type:'save'})
              }else{
                this.$message.error(res.msg)
              }
            }).catch(err => {
              this.$message.error(err)
            })
          }
      })

    },
  }
}
</script>
<style>
.list-top-margin .el-input-group__append, .el-input-group__prepend{
  color: #fff;
  background-color: #409EFF;
  border-radius: 0 4px 4px 0;
}
.select-count-content{
  position: absolute;
  left: 0;
  top: -45px;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/views/basicData/unit/create-dialog.vue